import { PayloadAction } from '@reduxjs/toolkit'
import { MasterApi, MasterFieldDef } from '@ulysses-inc/harami_api_client'
import { call, put, takeLatest } from 'redux-saga/effects'
import interceptionsActions from 'src/state/ducks/interceptions/actions'
import {
  getProductMasterFieldDefsFailed,
  getProductMasterFieldDefsRequested,
  getProductMasterFieldDefsSucceeded,
} from 'src/state/ducks/productMasterFieldDefs/slice'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import {
  handleHTTPError,
  isHTTPError,
} from 'src/state/middleware/saga/handleHttpError'

const getMasterFieldDefsByMasterUuidRequest = (masterUuid: string) => {
  return baseClient
    .getApi(MasterApi)
    .getMasterFieldDefs({ masterUuid })
    .then(response => response)
    .catch(handleHTTPError)
}

function* getProductMasterFieldDefs(action: PayloadAction<string | undefined>) {
  try {
    const masterUuid = action.payload
    if (!masterUuid) {
      yield put(getProductMasterFieldDefsSucceeded([]))
      return
    }
    const responseProductMasterFieldDefs: MasterFieldDef[] = yield call(
      getMasterFieldDefsByMasterUuidRequest,
      masterUuid,
    )
    yield put(
      getProductMasterFieldDefsSucceeded(responseProductMasterFieldDefs),
    )
  } catch (error) {
    if (isHTTPError(error) || error instanceof Error) {
      yield put(interceptionsActions.handleHttpError(error))
    } else {
      yield put(
        interceptionsActions.handleHttpError(
          new Error('Unknown error occurred'),
        ),
      )
    }
    yield put(getProductMasterFieldDefsFailed())
  }
}

const sagas = [
  takeLatest(
    getProductMasterFieldDefsRequested.type,
    getProductMasterFieldDefs,
  ),
]

export default sagas
